import request from "@/service";

/* 教学计划详情 */
export function getTeachingPlanInfo(params) {
  return request({
    url: `/study/class/teachingPlan/info/${params}`,
    method: "get"
  });
}

/* 教学计划新增 */
export function teachingPlanSave(data) {
  return request({
    url: `/study/class/teachingPlan/save`,
    method: "post",
    data
  });
}
